import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import accountRoutes from '@/router/routes/account.js'
import serviceRoutes from '@/router/routes/service.js'
import newsRoutes from '@/router/routes/news.js'
import ppdRoutes from '@/router/routes/ppd.js'

export default allRoutes.concat(
  publicRoutes,
  privateRoutes,
  accountRoutes,
  serviceRoutes,
  newsRoutes,
  ppdRoutes
)